import React from 'react'

export const BadgeWithCount: React.FC<{ count: number; placement: 'icon' | 'menu' }> = (props) => {
  const { count, placement } = props
  let styles
  switch (placement) {
    case 'icon': {
      styles = {
        position: 'absolute' as const,
        left: '26px',
        top: 0,
      }
      break
    }
    case 'menu': {
      styles = {
        marginLeft: '4px',
      }
      break
    }
  }
  return (
    <span
      style={{
        color: 'white',
        background: 'red',
        display: 'flex',
        justifyContent: 'center',
        minWidth: '16px',
        height: '16px',
        lineHeight: '16px',
        borderRadius: '9px',
        fontSize: '11px',
        padding: '0 4px',
        ...styles,
      }}
    >
      {count}
    </span>
  )
}
